import React from "react";

// Source of Funds options from ProSelect Contract June 2025 (Page 3)
const SOURCE_OF_FUNDS_OPTIONS = [
  { id: "sof1", name: "Business Income" },
  { id: "sof2", name: "Bank Account/Money Market" },
  { id: "sof3", name: "Advisory Account" },
  { id: "sof4", name: "Inheritance" },
  { id: "sof5", name: "Insurance/Annuity Contract", asterisk: true },
  { id: "sof6", name: "Brokerage Account" },
  { id: "sof7", name: "Legal Settlement" },
  { id: "sof8", name: "Mutual Funds/ETFs/UITs", asterisk: true },
  { id: "sof9", name: "Employer Retirement Plan" },
  { id: "sof10", name: "Salary/Employer Bonus" },
  { id: "sof11", name: "Stocks/Bonds" },
  { id: "sof12", name: "Gift From Immediate Relative" },
  { id: "sof13", name: "Other" },
];

const SourceOfFunds = ({ selected, onToggle, textValues, onTextChange }) => {
  const giftChecked = selected.includes("Gift From Immediate Relative");
  const otherChecked = selected.includes("Other");

  // Show the asterisk question when Insurance/Annuity Contract or Mutual Funds/ETFs/UITs is selected
  const asteriskSelected = SOURCE_OF_FUNDS_OPTIONS
    .filter((o) => o.asterisk)
    .some((o) => selected.includes(o.name));

  return (
    <div>
      {/* Standard Bootstrap 4 inline checkboxes */}
      <div className="row">
        {SOURCE_OF_FUNDS_OPTIONS.map((option) => (
          <div className="col-sm-6 col-md-4" key={option.id}>
            <div className="form-check" style={{ marginBottom: "4px" }}>
              <input
                className="form-check-input"
                type="checkbox"
                id={option.id}
                checked={selected.includes(option.name)}
                onChange={() => onToggle(option.name)}
                style={{ height: "15px", width: "15px" }}
              />
              <label
                className="form-check-label"
                htmlFor={option.id}
                style={{ fontSize: "inherit" }}
              >
                {option.name}{option.asterisk ? "*" : ""}
              </label>
            </div>
          </div>
        ))}
      </div>

      {/* Mandatory asterisk question for starred selections */}
      {asteriskSelected && (
        <div
          className="form-group mt-2 mb-2"
          style={{
            borderLeft: `5px solid ${textValues["advisorSoldFunds"] ? "green" : "#ced4da"}`,
            paddingLeft: "12px",
          }}
        >
          <label style={{ fontSize: "inherit" }}>
            <strong>*Does the source of funds include any Mutual Funds, UITs, or VAs that were sold by the IAR in the last 3 years?</strong>
          </label>
          <div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="advisorSoldFunds"
                id="advisorSoldFundsYes"
                value="Yes"
                checked={textValues["advisorSoldFunds"] === "Yes"}
                onChange={(e) => onTextChange("advisorSoldFunds", e.target.value)}
                style={{ height: "15px", width: "15px" }}
              />
              <label className="form-check-label" htmlFor="advisorSoldFundsYes">Yes</label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="advisorSoldFunds"
                id="advisorSoldFundsNo"
                value="No"
                checked={textValues["advisorSoldFunds"] === "No"}
                onChange={(e) => onTextChange("advisorSoldFunds", e.target.value)}
                style={{ height: "15px", width: "15px" }}
              />
              <label className="form-check-label" htmlFor="advisorSoldFundsNo">No</label>
            </div>
          </div>
        </div>
      )}

      {/* Conditional text fields below the grid */}
      {giftChecked && (
        <div
          className="form-group mt-2 mb-2"
          style={{
            borderLeft: `5px solid ${textValues["Gift From Immediate Relative"]?.trim() ? "green" : "#ced4da"}`,
            paddingLeft: "12px",
          }}
        >
          <label htmlFor="sof-gift-text" style={{ fontSize: "inherit" }}>
            <strong>Gift From Immediate Relative:</strong> What is the
            relationship to the Account Owner?
          </label>
          <input
            type="text"
            id="sof-gift-text"
            className="form-control"
            placeholder="Enter relationship"
            value={textValues["Gift From Immediate Relative"] || ""}
            onChange={(e) =>
              onTextChange("Gift From Immediate Relative", e.target.value)
            }
            maxLength={200}
          />
          <small className="form-text text-muted text-right d-block">
            {(textValues["Gift From Immediate Relative"] || "").length}/200
          </small>
        </div>
      )}

      {otherChecked && (
        <div
          className="form-group mt-2 mb-1"
          style={{
            borderLeft: `5px solid ${textValues["Other"]?.trim() ? "green" : "#ced4da"}`,
            paddingLeft: "12px",
          }}
        >
          <label htmlFor="sof-other-text" style={{ fontSize: "inherit" }}>
            <strong>Other:</strong> Please specify
          </label>
          <input
            type="text"
            id="sof-other-text"
            className="form-control"
            placeholder="Specify source of funds"
            value={textValues["Other"] || ""}
            onChange={(e) => onTextChange("Other", e.target.value)}
            maxLength={200}
          />
          <small className="form-text text-muted text-right d-block">
            {(textValues["Other"] || "").length}/200
          </small>
          <small className="form-text text-danger">
            Reverse mortgages, home equity loans, and loan advances are
            prohibited sources of funds.
          </small>
        </div>
      )}
    </div>
  );
};

export default SourceOfFunds;
